<script>
  import CustomNotification from "./views/CustomNotification.svelte";
  import { Router } from "svelte-router-spa";
  import { routes } from "./routes.js";
  import Notifications from "svelte-notifications";
</script>

<Notifications item={CustomNotification}>
  <Router {routes} />
</Notifications>